
export default {
  async asyncData({ $getContent }) {
    return {
      questions: await $getContent('faq'),
    }
  },
  head: {
    title: 'FAQ',
  },
}
